import { render, staticRenderFns } from "./app-detail-fire-scroll.vue?vue&type=template&id=2afa1595&scoped=true&"
import script from "./app-detail-fire-scroll.vue?vue&type=script&lang=js&"
export * from "./app-detail-fire-scroll.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-fire-scroll.vue?vue&type=style&index=0&id=2afa1595&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa1595",
  null
  
)

export default component.exports